import { graphql } from '@/gql';
import type { UpdatePartnerUserMutation, UpdatePartnerUserMutationVariables } from '@/gql/graphql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export type UpdatePartnerUserInput = UpdatePartnerUserMutationVariables['data'];
export type PartnerUser = UpdatePartnerUserMutation['updatePartnerUser'];

export const updatePartnerUser = async (codeName: string, userId: string, data: UpdatePartnerUserInput): Promise<PartnerUser> => {
  const response = await mutationExecute({
    mutation: graphql(`
      mutation UpdatePartnerUser($codeName: String!, $userId: String!, $data: UpdatePartnerUserInputType!) {
        updatePartnerUser(codeName: $codeName, userId: $userId, data: $data) {
          id
          firstName
          lastName
          email
          highestRole
          isActive
        }
      }
    `),
    variables: {
      codeName,
      userId,
      data,
    },
  });

  return response.data!.updatePartnerUser;
};
